import { formatInTimeZone } from "date-fns-tz";
import { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import SweetAlert2 from "react-sweetalert2";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";
import DateRangeComp from "../../common/DateRangeComp";
import * as actions from "../redux/RefundNPromotionAction";
import { MemberRefundEffDialog } from "./MemberRefundEff";
import { ProceedDialog } from "./ProceedDialog";

export const MemberRefund = ({}) => {
  const [swalProps, setSwalProps] = useState({});
  const [show, setShow] = useState(false);
  const intl = useIntl();
  const dispatch = useDispatch();
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  const startOfYesterday = new Date(yesterday.setHours(0, 0, 0, 0));
  const endOfYesterday = new Date(yesterday.setHours(23, 59, 59, 999));
  const [fromDate, setFromDate] = useState(startOfYesterday);
  const [toDate, setToDate] = useState(endOfYesterday);
  const [selectedDirectionBaseOn, setSelectedDirectionBaseOn] = useState("");
  const [selectedDirection, setSelectedDirection] = useState("");
  const [selectedRefundType, setSelectedRefundType] = useState("");
  const [selectedLevel, setSelectedLevel] = useState("");
  const [selectedGameType, setSelectedGameType] = useState("");
  const [minuspromo, setMinuspromo] = useState(false);
  const [queryParams, setQueryParams] = useState();

  const [selectedDirectionNum, setSelectedDirectionNum] = useState("");
  const [selectedRefundNumber, setSelectedRefundNumber] = useState("");

  const [refundList, setRefundList] = useState();
  const timeZone = "Asia/Kuala_Lumpur";
  const refundNPromotionState = useSelector(
    ({ refundNPromotion }) => refundNPromotion,
    shallowEqual
  );
  const queryParamsRef = useRef({});

  useEffect(() => {
    const queryParams = {
      action: "memberrefundui",
    };
    dispatch(actions.fetchMemberRefundUi(queryParams)).then((resp) => {
      resp = resp.data;
      setSelectedDirectionBaseOn(resp.directionBaseOnLists[0].code);
      setSelectedDirection(resp.directionLists[0].code);
      setSelectedRefundType(resp.refundTypeLists[0].code);
      setSelectedGameType(resp.gameTypeLists[0].gametype);
      setSelectedLevel(resp.levelLists[0].code);
    });

    return () => {
      dispatch(actions.clearMemberRefund());
    };
  }, []);

  const handleDateChange = (start, end) => {
    setFromDate(start);
    setToDate(end);
  };

  const handleSearchClick = () => {
    queryParamsRef.current = {
      action: "memberrefundcount",
      fromdate: formatInTimeZone(fromDate, timeZone, "yyyy-MM-dd"),
      todate: formatInTimeZone(toDate, timeZone, "yyyy-MM-dd"),
      directionbaseon: selectedDirectionBaseOn,
      direction: selectedDirection,
      directionamt: selectedDirectionNum,
      refundtype: selectedRefundType,
      refundnumber: selectedRefundNumber,
      gametype: selectedGameType,
      level: selectedLevel,
      minuspromo: minuspromo.toString(),
    };
    dispatch(actions.callMemberRefundList(queryParamsRef.current)).then(
      (resp) => {
        resp = resp.data;
        setRefundList(resp);
        if (parseInt(resp.code) === ApiStatusTypeEnum.COMMON_ERROR) {
          setSwalProps({
            show: true,
            icon: "error",
            title: intl.formatMessage({ id: "error" }),
            text: resp.message,
          });
        }
      }
    );
  };

  const handleRefundNumChange = (e) => {
    setSelectedRefundNumber(e.target.value);
  };

  const handleDirectionNumChange = (e) => {
    setSelectedDirectionNum(e.target.value);
  };

  return (
    <div style={{ width: "100%", margin: "0 auto" }}>
      <SweetAlert2
        customClass="custom-swal"
        onResolve={() => {
          setSwalProps({});
        }}
        {...swalProps}
      />
      <MemberRefundEffDialog
        setQueryParams={setQueryParams}
        queryParams={queryParams}
        setSwalProps={setSwalProps}
      />
      <ProceedDialog
        setSwalProps={setSwalProps}
        refundList={refundList}
        show={show}
        setShow={setShow}
      />
      <div>
        <h2>{intl.formatMessage({ id: "memberRefund" })}</h2>
      </div>
      <div className="d-flex justify-content-between">
        <DateRangeComp
          initialRange={[
            { startDate: fromDate, endDate: toDate, key: "selection" },
          ]}
          onDateChange={handleDateChange}
        />
      </div>
      <div className="my-2">
        {refundNPromotionState.memberRefundUi && (
          <div>
            {intl.formatMessage({ id: "direction" })}
            <div
              className="mb-2"
              style={{ borderBottom: "1px solid rgba(175, 164, 164, 0.4)" }}
            >
              <select
                className="dropdown respond-Select"
                value={selectedDirectionBaseOn}
                onChange={(e) => {
                  setSelectedDirectionBaseOn(e.target.value);
                  setMinuspromo(false);
                }}
              >
                {refundNPromotionState.memberRefundUi.directionBaseOnLists.map(
                  (value, index) => (
                    <option key={index} value={value.code}>
                      {value.description}
                    </option>
                  )
                )}
              </select>
              <select
                className="dropdown respond-Select"
                value={selectedDirection}
                onChange={(e) => setSelectedDirection(e.target.value)}
              >
                {refundNPromotionState.memberRefundUi.directionLists.map(
                  (value, index) => (
                    <option key={index} value={value.code}>
                      {value.description}
                    </option>
                  )
                )}
              </select>
              <input
                type="number"
                className="refund-Input"
                placeholder={intl.formatMessage({ id: "directionAmount" })}
                value={selectedDirectionNum}
                onChange={handleDirectionNumChange}
              />
              <select
                className="dropdown respond-Select"
                value={selectedLevel}
                onChange={(e) => setSelectedLevel(e.target.value)}
              >
                {refundNPromotionState.memberRefundUi?.levelLists?.map(
                  (value, index) => (
                    <option key={index} value={value.code}>
                      {value.description}
                    </option>
                  )
                )}
              </select>
              {selectedDirectionBaseOn === "winlose" && (
                <div className="form-check d-inline-block">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value=""
                    id="checkDefault"
                    checked={minuspromo}
                    onChange={(e) => setMinuspromo(e.target.checked)}
                  />
                  <label className="form-check-label" for="checkDefault">
                    {intl.formatMessage({ id: "minusPromotionClaim" })}
                  </label>
                </div>
              )}
            </div>
            {intl.formatMessage({ id: "refundBy" })}
            <div className="d-flex justify-content-between">
              <div>
                <select
                  className="dropdown respond-Select"
                  value={selectedGameType}
                  onChange={(e) => setSelectedGameType(e.target.value)}
                >
                  {refundNPromotionState.memberRefundUi?.gameTypeLists?.map(
                    (value, index) => (
                      <option key={index} value={value.gametype}>
                        {value.gametype}
                      </option>
                    )
                  )}
                </select>
                <select
                  className="dropdown respond-Select"
                  value={selectedRefundType}
                  onChange={(e) => setSelectedRefundType(e.target.value)}
                >
                  {refundNPromotionState.memberRefundUi.refundTypeLists.map(
                    (value, index) => (
                      <option key={index} value={value.code}>
                        {value.description}
                      </option>
                    )
                  )}
                </select>
                <input
                  type="number"
                  className="refund-Input"
                  placeholder={intl.formatMessage({ id: "refundNumber" })}
                  value={selectedRefundNumber}
                  onChange={handleRefundNumChange}
                />
              </div>

              <div className="d-flex align-items-center">
                <div className="mx-2">
                  <button
                    className="btn btn-primary"
                    onClick={handleSearchClick}
                  >
                    {intl.formatMessage({ id: "calculate" })}
                  </button>
                </div>
                {refundList?.memberRefundLists &&
                  refundList.memberRefundLists.length > 0 && (
                    <div>
                      <button
                        className="btn btn-success"
                        onClick={() => setShow(true)}
                      >
                        {intl.formatMessage({ id: "publish" })}
                      </button>
                    </div>
                  )}
              </div>
            </div>
          </div>
        )}
      </div>
      {refundList && (
        <div
          className={`rounded d-flex align-items-center justify-content-spacebetween py-2 gamelistDiv1 cursor-pointer position-relative text-center mobile-overflow`}
          style={{
            border: "1px solid grey",
            padding: "2px",
            margin: "10px 0 ",
          }}
        >
          <div style={{ width: "100%" }}>
            <table
              className="text-start table-report"
              style={{
                width: "100%",
                minWidth: "1000px",
              }}
            >
              <tbody>
                <tr>
                  <td className="col-3 td-line">
                    {intl.formatMessage({ id: "originalRefund" }) +
                      " : " +
                      refundList?.totalrefund}
                  </td>
                  <td className="col-3 text-danger td-line">
                    {intl.formatMessage({ id: "refundBefore" }) + " "}:
                    {refundList?.refundbefore === "true" ? " Yes" : " No"}
                  </td>
                  <td className="col-3 ">
                    {intl.formatMessage({ id: "actualRefund" }) +
                      " : " +
                      refundList?.memberRefundLists
                        ?.filter(
                          (memberRefund) =>
                            memberRefund.bonusgain &&
                            !isNaN(parseFloat(memberRefund.bonusgain))
                        )
                        ?.map((memberRefund) =>
                          parseFloat(memberRefund.bonusgain)
                        )
                        ?.reduce((acc, val) => acc + val, 0)
                        ?.toFixed(2) ?? "0.00"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
      <div
        className="member-div d-flex"
        style={{
          margin: "10px auto",
        }}
      >
        <div className="member-container">
          <div className="table-responsive">
            <table className="member-table">
              <thead className="member-header1">
                <tr className="member-row1">
                  <th className="member-cell hide-on-mobile">
                    {intl.formatMessage({ id: "no" })}
                  </th>
                  <th className="member-cell text-start text-nowrap">
                    {intl.formatMessage({ id: "username" })}
                  </th>
                  <th className="member-cell text-end text-nowrap">
                    {intl.formatMessage({ id: "bet" })}
                  </th>
                  <th className="member-cell text-end text-nowrap">
                    {intl.formatMessage({ id: "winLose" })}
                  </th>
                  <th className="member-cell text-end text-nowrap">
                    {intl.formatMessage({ id: "promotionAmount" })}
                  </th>
                  <th className="member-cell text-nowrap text-end text-nowrap">
                    {intl.formatMessage({ id: "actualAmount" })}
                  </th>
                  <th className="member-cell text-nowrap text-end pe-2">
                    {intl.formatMessage({ id: "bonusGain" })}
                  </th>
                  <th className="member-cell text-nowrap text-start pe-2">
                    {intl.formatMessage({ id: "effCount" })}
                  </th>
                </tr>
              </thead>
              <tbody className="member-body">
                {refundList?.memberRefundLists &&
                refundList.memberRefundLists.length > 0 ? (
                  refundList.memberRefundLists.map((report, index) => (
                    <tr key={index} className="member-row1">
                      <td className="member-cell hide-on-mobile">
                        {index + 1}
                      </td>
                      <td className="member-cell text-start">
                        {report.username}
                      </td>
                      <td className="member-cell text-end">{report.bet}</td>
                      <td className="member-cell text-end">{report.winlose}</td>
                      <td className="member-cell text-end">
                        {report.promoamt}
                      </td>
                      <td className="member-cell text-end">
                        {report.actamount}
                      </td>
                      <td className="member-cell text-end pe-2">
                        <input
                          type="number"
                          className="refund-Input text-end"
                          placeholder="0"
                          value={report.bonusgain}
                          onChange={(e) => {
                            setRefundList((prev) => {
                              const updatedList = [...prev.memberRefundLists];
                              updatedList[index] = {
                                ...updatedList[index],
                                bonusgain: e.target.value,
                                isedited: "true",
                              };

                              return {
                                ...prev,
                                memberRefundLists: updatedList,
                              };
                            });
                          }}
                        />
                      </td>
                      <td className="member-cell text-start">
                        <span
                          className={
                            report.effcount !== "0" ? "text-primary" : ""
                          }
                          style={
                            report.effcount !== "0" ? { cursor: "pointer" } : {}
                          }
                          onClick={() => {
                            setQueryParams({
                              action: "memberrefundefflist_new",
                              memberid: report.memberid,
                              level: queryParamsRef.current.level,
                              fromdate: queryParamsRef.current.fromdate,
                              todate: queryParamsRef.current.todate,
                              directionbaseon:
                                queryParamsRef.current.directionbaseon,
                              directionamt: queryParamsRef.current.directionamt,
                              direction: queryParamsRef.current.direction,
                              minuspromo: queryParamsRef.current.minuspromo,
                              gametype: queryParamsRef.current.gametype,
                            });
                          }}
                        >
                          {report.effcount}
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8">
                      <div className="no-record-wrapper oRecordDiv">
                        <i className="bi bi-search fs-1 mb-3" />
                        <div className="text-font2">
                          {intl.formatMessage({ id: "noRecordFound" })}
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
